export default __webpack_public_path__ + "static/Museo-Sans-300-Italic-5b75309e861adeee7d399a2c75f82064.woff";